import React from "react";
import { Pill } from "./Pill";
import type { SAStatus } from "../../sa";

export interface SAStatusPillProps {
  status: SAStatus;
  info?: { checks_registered?: number } | null;
}

/* Shows the Senior Associate service status (online / checking / offline /
   not configured) in the Usage panel, with a tooltip hint about reachability. */
export function SAStatusPill({ status, info }: SAStatusPillProps): JSX.Element {
  const colors: Record<SAStatus, string> = {
    checking: "--low",
    online: "--green",
    offline: "--amber",
    not_configured: "--low",
  };
  const labels: Record<SAStatus, string> = {
    checking: "checking…",
    online: "online",
    offline: "offline — pre-baked",
    not_configured: "not configured",
  };
  return (
    <span
      className="ttrigger"
      data-tip={
        status === "online"
          ? "Senior Associate API reachable" +
            (info && info.checks_registered ? " · " + info.checks_registered + " checks" : "")
          : status === "offline"
            ? "Senior Associate API not reachable. Showing pre-baked findings."
            : status === "not_configured"
              ? "Set VITE_SA_BASE_URL to connect a Senior Associate service. Showing pre-baked findings."
              : "Probing the SA service health endpoint…"
      }
    >
      <Pill color={colors[status]} label={"SA · " + labels[status]} />
    </span>
  );
}
